import { clone, cloneDeep } from "lodash";
import { DEACTIVATE_FORCES_INPUT_ERROR, DEACTIVATE_FORCES_INPUT_STARTING, DEACTIVATE_FORCES_INPUT_SUCCESS } from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function deactivateForcesInputReducer(state = initialState.deactivateForcesInput, action) {
    switch (action.type) {
        case DEACTIVATE_FORCES_INPUT_STARTING: {
            const { forcesInputId } = action;
            const newState = cloneDeep(state);

            if (!newState[forcesInputId]) {
                newState[forcesInputId] = cloneDeep(initialState.deactivateForcesInput.forcesInputId);
            }

            const forceData = newState[forcesInputId];
            forceData.saving = true;
            forceData.saved = false;
            forceData.error = null;

            return newState;
        }

        case DEACTIVATE_FORCES_INPUT_SUCCESS: {
            const { forcesInputId } = action;
            const newState = cloneDeep(state);

            if (!newState[forcesInputId]) {
                newState[forcesInputId] = cloneDeep(initialState.deactivateForcesInput.forcesInputId);
            }

            const forceData = newState[forcesInputId];
            forceData.saving = false;
            forceData.saved = true;
            forceData.error = null;

            return newState;
        }

        case DEACTIVATE_FORCES_INPUT_ERROR: {
            const { forcesInputId } = action;
            const newState = cloneDeep(state);

            if (!newState[forcesInputId]) {
                newState[forcesInputId] = cloneDeep(initialState.deactivateForcesInput.forcesInputId);
            }

            const forceData = newState[forcesInputId];
            forceData.saving = false;
            forceData.saved = false;
            forceData.error = action.err;

            return newState;
        }

        default: {
            return state;
        }
    }
}
